import * as React from 'react';
import { useRef } from 'react';
import { useContainerMeasurement } from '@zoopla/dom-util';
import {
    StyledMiniCard,
    StyledListingCardMiniColumn,
    StyledMiniCardLink
} from './ListingCardMini.styles';

export type ListingCardMiniProps = {
    testId: string;
    listingLinkHref?: string;
    trackClick?: () => void;
    children?: React.ReactNode;
    isSmall?: boolean;
};

export const ListingCardMini = ({
    testId,
    listingLinkHref,
    trackClick,
    children,
    isSmall = false
}: ListingCardMiniProps) => (
    <StyledMiniCard data-testid={testId} isSmall={isSmall}>
        {listingLinkHref ? (
            <StyledMiniCardLink onClick={trackClick} href={listingLinkHref} />
        ) : null}
        {children}
    </StyledMiniCard>
);

const SHRINK_BREAKPOINT = 380;

export const ListingCardMiniColumnWithShrinkBreakpoint = ({
    children
}: {
    children: React.ReactNode;
}) => {
    const containerRef = useRef<HTMLDivElement>(null);
    const [containerWidth] = useContainerMeasurement(containerRef);
    const isSmall = containerWidth < SHRINK_BREAKPOINT;

    return (
        <StyledListingCardMiniColumn ref={containerRef}>
            {React.Children.map(children, (child) => {
                if (React.isValidElement(child)) {
                    return React.cloneElement(child, { isSmall });
                }

                return null;
            })}
        </StyledListingCardMiniColumn>
    );
};
